import styled from "styled-components";

export const Select = styled.select`
  width: 100%;
  height: 36px;
  padding: 0 12px;

  border-radius: 8px;
  border: 1px solid ${({ error }) => (error ? "#ef4444" : "#e5e7eb")};

  font-size: 14px;
  background: white;
  color: #111827;

  outline: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${({ error }) => (error ? "#ef4444" : "#111827")};
    box-shadow: ${({ error }) =>
      error
        ? "0 0 0 2px rgba(239, 68, 68, 0.1)"
        : "0 0 0 2px rgba(17, 24, 39, 0.1)"};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
